<template>
    <div class="pl-document-item-slot">
        <link-slot :slots="[p_slot]" v-if="!!p_slot"/>
    </div>
</template>

<script>
    export default {
        name: "link-document-item-slot",
        props: ['data'],
        data() {
            return {
                p_slot: null,
                document: null,
            }
        },
        created() {
            this.document = this.$lv.$dom.findComponentUpward(this, 'link-document')
            this.p_slot = this.document.$slots[this.data.setting.slot]
        }
    }
</script>

<style lang="scss">

</style>
